import React, { useState } from "react";

const SuspectGizmo = ({isOpen}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      style={{ width: "60px", height: "60px", cursor: "pointer" }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {isOpen ? (
        <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.25" y="0.25" width="59.5" height="59.5" rx="4.75" fill="#4EABFF" fill-opacity="0.6"/>
        <rect x="0.25" y="0.25" width="59.5" height="59.5" rx="4.75" stroke="black" stroke-width="0.5"/>
        <rect x="0.25" y="0.25" width="59.5" height="59.5" rx="4.75" stroke="#007BDA" stroke-opacity="0.34" stroke-width="0.5"/>
        <g>
          <path d="M30 11 A19 19 0 1 1 29.999 11 Z" fill="red" />
          <path d="M30 11 A19 19 0 0 0 29.999 49 Z" fill="green" />
          <circle cx="30" cy="30" r="19" fill="none" stroke={isOpen ? '#007BDA' : ''} />
        </g>
        </svg>
      ) :
      isHovered ? (
        // Hover SVG
        <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="60" height="60" rx="5" fill="#0D1320"/>
        <rect x="0.25" y="0.25" width="59.5" height="59.5" rx="4.75" stroke="#1A1D25" stroke-opacity="0.5" stroke-width="0.5"/>
        <g opacity="0.08">
        <rect width="60" height="60" rx="5" fill="white"/>
        <rect x="0.15" y="0.15" width="59.7" height="59.7" rx="4.85" stroke="#1A1D25" stroke-opacity="0.2" stroke-width="0.3"/>
        </g>
        <g>
          <path d="M30 11 A19 19 0 1 1 29.999 11 Z" fill="red" />
          <path d="M30 11 A19 19 0 0 0 29.999 49 Z" fill="green" />
          <circle cx="30" cy="30" r="19" fill="none" stroke={isOpen ? '#007BDA' : ''} />
        </g>
        </svg>
      ) : (
        // Default SVG
        <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="60" height="60" rx="5" fill="#0D1320"/>
        <rect x="0.25" y="0.25" width="59.5" height="59.5" rx="4.75" stroke="#1A1D25" stroke-opacity="0.5" stroke-width="0.5"/>
        <g>
          <path d="M30 11 A19 19 0 1 1 29.999 11 Z" fill="red" />
          <path d="M30 11 A19 19 0 0 0 29.999 49 Z" fill="green" />
          <circle cx="30" cy="30" r="19" fill="none" stroke={isOpen ? '#007BDA' : ''} />
        </g>
        </svg>
      )}
    </div>
  )
}

export default SuspectGizmo
